export default "__VITE_ASSET__CjX00eFo__"